// extracted by mini-css-extract-plugin
export default {"masterContainer":"Explosion_masterContainer__4Sp79","particle":"Explosion_particle__gb-HP","shoot":"Explosion_shoot__0af5z","fade":"Explosion_fade__MNgf-"};